import { Typography } from '@ag1/ui';
import { type ImageContentHighlight } from 'types/studio/studio';
import { CustomPortableText } from 'shared/studio/PortableText';
import { styles } from './ImageContentHighlightHeading.css';

type ImageContentHighlightHeadingProps = Pick<
  ImageContentHighlight,
  'superHeadline' | 'headline' | 'subtitle'
>;

const ImageContentHighlightHeading = ({
  superHeadline,
  headline,
  subtitle
}: ImageContentHighlightHeadingProps) => (
  <div>
    {superHeadline && (
      <Typography
        component="strong"
        variant="captionMono"
        size="2"
        noPadding
        className={styles.superHeadline}>
        {superHeadline}
      </Typography>
    )}

    {headline && (
      <Typography variant="headlineSans" size="2" noPadding className={styles.headline}>
        <CustomPortableText addAccessibility value={headline} tag="h1" />
      </Typography>
    )}

    {subtitle && (
      <Typography
        component="h2"
        variant="portalSubtitle"
        size="2"
        noPadding
        className={styles.subtitle}>
        {subtitle}
      </Typography>
    )}
  </div>
);

export default ImageContentHighlightHeading;
